import { Box, Stack } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import useGetDeviceInfo from "hooks/useGetDeviceInfo";
import { theme } from "styles/theme";
import image1 from "static/image/promotion/1.png";
import image2 from "static/image/promotion/2.png";
import image3 from "static/image/promotion/3.png";
import image4_1 from "static/image/promotion/4-1.png";
import image4_2 from "static/image/promotion/4-2.png";
import image5 from "static/image/promotion/5.png";
import image6_1 from "static/image/promotion/6-1.png";
import image6_2 from "static/image/promotion/6-2.gif";
import image6_3 from "static/image/promotion/6-3.png";
import image7_1 from "static/image/promotion/7-1.png";
import image7_2 from "static/image/promotion/7-2.png";
import image7_3 from "static/image/promotion/7-3.png";
import image8 from "static/image/promotion/8.png";
import image9_1 from "static/image/promotion/9-1.png";
import image9_2 from "static/image/promotion/9-2.png";
import image10_1 from "static/image/promotion/10-1.png";
import image10_2 from "static/image/promotion/10-2.png";
import image10_3 from "static/image/promotion/10-3.png";
import image11 from "static/image/promotion/11.png";
import image12 from "static/image/promotion/12.png";

import useMixpanelWeb from "hooks/useMixpanelWeb";
import ReactPixel from "react-facebook-pixel";
import PromotionPaymentButton from "./PromotionPaymentButton";
import ContentTemplateV2 from "components/task/content/ContentTemplateV2";
import FloatingAreaPromotion from "components/common/FloatingAreaPromotion";

export default function Promotion() {
  const floatingAreaRef = useRef<HTMLDivElement>(null);

  const fullWidth = true;

  const setMixPanel = useMixpanelWeb({
    eventName: "프로모션 페이지 진입",
  });

  const sentMixpanelRef = useRef(false);

  useEffect(() => {
    if (!sentMixpanelRef.current) {
      setMixPanel();
      sentMixpanelRef.current = true;

      ReactPixel.track("ViewContent");
    }
  }, []);

  const { homeIndicatorHeight } = useGetDeviceInfo();
  const [containerHeight, setContainerHeight] = useState<number>(
    window.innerHeight - homeIndicatorHeight
  );
  const [floatingAreaHeight, setFloatingAreaHeight] = useState<number>(0);

  useEffect(() => {
    setTimeout(() => {
      setFloatingAreaHeight(floatingAreaRef.current?.offsetHeight || 0);
    }, 100);
  }, [floatingAreaRef.current]);

  return (
    <ContentTemplateV2
      noPadding
      noBottomPaddingChildren
      isWide
      setContainerHeight={setContainerHeight}
    >
      {containerHeight > 0 && (
        <Stack
          sx={{
            backgroundColor: theme.vars.palette.Background.Level3,
          }}
        >
          {
            <Stack
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                width: "100%",
                mx: "auto",
                px: 0,
              }}
            >
              <Stack
                direction="column"
                alignItems="start"
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <img
                  src={image1}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image2}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image3}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image4_1}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image4_2}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image5}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image6_1}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image6_2}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image6_3}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image7_1}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image7_2}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image7_3}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image8}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image9_1}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image9_2}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image10_1}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image10_2}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image10_3}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image11}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
                <img
                  src={image12}
                  alt={"empty"}
                  style={{
                    width: "100%",
                  }}
                />
              </Stack>
            </Stack>
          }

          <Box>
            <FloatingAreaPromotion
              fullWidth={fullWidth}
              ref={floatingAreaRef}
              noDivider={true}
              // paddingBottom={isInappWebview ? "4px" : "12px"}
              backgroundColor={"transparent"}
              paddingBottom={"8px"}
            >
              <Stack
                spacing={1.5}
                sx={{ width: "100%" }}
                alignItems="center"
                justifyContent={"space-between"}
              >
                <Stack
                  spacing={"16px"}
                  sx={{
                    width: "100%",
                    mx: "auto",
                    paddingBottom: "8px",
                  }}
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  <PromotionPaymentButton selectedPlan={"challenger"} />
                </Stack>
              </Stack>
            </FloatingAreaPromotion>
          </Box>
        </Stack>
      )}
    </ContentTemplateV2>
  );
}
